export const LAYERS = {
  "Pan inferior": { h: 34, draw: (y) => <rect x="20" y={y} width="240" height="34" rx="16" fill="#E0A85A" stroke="#B9803A" strokeWidth="2" /> },
  Carne: { h: 26, draw: (y) => <rect x="24" y={y} width="232" height="26" rx="11" fill="#7A4A2B" stroke="#4E2D18" strokeWidth="2" /> },
  Queso: { h: 14, draw: (y) => (
    <g><rect x="16" y={y} width="248" height="14" rx="4" fill="#F6C744" stroke="#D9A21B" strokeWidth="1.5" />
      <rect x="40" y={y + 10} width="14" height="14" rx="6" fill="#F6C744" /><rect x="220" y={y + 10} width="14" height="18" rx="6" fill="#F6C744" /></g>) },
  Tomate: { h: 16, draw: (y) => <rect x="30" y={y} width="220" height="16" rx="8" fill="#E0392E" stroke="#A8231B" strokeWidth="2" /> },
  Lechuga: { h: 22, draw: (y) => (
    <g><rect x="10" y={y} width="260" height="22" rx="11" fill="#7BC043" stroke="#4E8A26" strokeWidth="2" />
      {[30, 80, 130, 180, 230].map((x) => <circle key={x} cx={x} cy={y + 20} r="9" fill="#7BC043" stroke="#4E8A26" strokeWidth="2" />)}</g>) },
  Cebolla: { h: 12, draw: (y) => <rect x="40" y={y} width="200" height="12" rx="6" fill="#E6D4F0" stroke="#8E5FA8" strokeWidth="2.5" /> },
  Pepino: { h: 14, draw: (y) => <g>{[80, 140, 200].map((x) => <ellipse key={x} cx={x} cy={y + 7} rx="34" ry="7" fill="#5E9E3E" stroke="#2F6B1C" strokeWidth="2" />)}</g> },
  Piña: { h: 16, draw: (y) => <rect x="40" y={y} width="200" height="16" rx="8" fill="#F5D24B" stroke="#D9A21B" strokeWidth="2" /> },
  "Pan superior": { h: 52, draw: (y) => (
    <g><path d={`M20,${y + 52} a120,52 0 0 1 240,0 z`} fill="#E0A85A" stroke="#B9803A" strokeWidth="2" />
      {[[80, 22], [120, 12], [160, 12], [200, 22], [140, 30], [100, 36], [180, 36]].map(([x, dy], i) => (
        <ellipse key={i} cx={x} cy={y + dy} rx="5" ry="2.5" fill="#FBEBC8" transform={`rotate(${(i % 3) * 30 - 30} ${x} ${y + dy})`} />))}</g>) },
};
export const INGREDIENTS = Object.keys(LAYERS);

export const Burger = ({ stack, className, svgRef, testid }) => {
  const total = stack.reduce((a, k) => a + LAYERS[k].h - 4, 0) + 40;
  const H = Math.max(260, total);
  let y = H - 20;
  const layers = stack.map((k, i) => { y -= LAYERS[k].h - 4; return <g key={i} data-testid={`burger-layer-${i}`}>{LAYERS[k].draw(y)}</g>; });
  return (
    <svg ref={svgRef} xmlns="http://www.w3.org/2000/svg" viewBox={`0 0 280 ${H}`} className={className} data-testid={testid}>
      <rect x="0" y="0" width="280" height={H} rx="24" fill="#FFF6E9" />
      <ellipse cx="140" cy={H - 14} rx="130" ry="10" fill="#E9D9C3" />
      {layers}
    </svg>
  );
};

export const LayerIcon = ({ name }) => (
  <svg viewBox="0 0 280 60" className="w-full h-8">{LAYERS[name].draw(name === "Pan superior" ? 4 : (60 - LAYERS[name].h) / 2)}</svg>
);
